module.exports = __webpack_public_path__ + "fonts/Raleway-Light.6c084270.ttf";